import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import * as React from "react";
import {Component} from "react";
import * as EnumStavObjednavka from "../api/gen/cgo/EnumStavObjednavka";
import * as StavObjednavkaInfo from "../api/EnumStavObjednavkaInfo";
import {WithTranslation, withTranslation} from "react-i18next";
import './StavObjednavka.scss';

/**
 * Barevný řádek zobrazující stav objednávky.
 */
class StavObjednavka extends Component<WithTranslation> {

    static propTypes = {
        stav: PropTypes.string.isRequired, // stav objednávky (EnumStavObjednavka)
    };

    render() {
        const {stav, t} = this.props;
        let className;
        switch (stav) {
            case EnumStavObjednavka.CEKA:
            case EnumStavObjednavka.CEKAVYJ:
                className = "cekajici";
                break;
            case EnumStavObjednavka.ZPRAC:
                className = "zpracovani";
                break;
            case EnumStavObjednavka.VYRIZ:
                className = "zhotovena";
                break;
            case EnumStavObjednavka.ZDCEN:
                className = "zadost";
                break;
            case EnumStavObjednavka.STORN:
                className = "stornovana";
                break;
            default:
                className = "neznamy";
        }
        return <span className={`stav-objednavka ${className}`}>{StavObjednavkaInfo.getCaption(stav, t)}</span>
    }
}

export default withTranslation()(connect()(StavObjednavka));
